// extracted by mini-css-extract-plugin
export default {"hello":"HelloText_hello__TIUp-","cursor":"HelloText_cursor__oSo7P","shortDescription":"HelloText_shortDescription__20Hce","type":"HelloText_type__Aoo3p"};